
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as detailPUMdEQjTbiE2zlk0EXILfbV2ZABuHAdhqU6aVqakQQ8Meta } from "/builds/triyaru/desktop-frontend-2/pages/about/company/detail.vue?macro=true";
import { default as document_45contentTquoUiIJ4ArVNFUQWTnA_k7SQAwqJoBJcUXCIO5YUXsMeta } from "/builds/triyaru/desktop-frontend-2/pages/about/legal/document-content.ts?macro=true";
import { default as ndaC_8g4sG8_Xq_V4R2ElHyKaIZ5ZEWnmxdhEEh8_GHfHwMeta } from "/builds/triyaru/desktop-frontend-2/pages/about/legal/nda.vue?macro=true";
import { default as offer8nBju0lbRdamUOeyBqnTgl22l0ElBE4AAoZKpY9Fz30Meta } from "/builds/triyaru/desktop-frontend-2/pages/about/legal/offer.vue?macro=true";
import { default as indexfNyINor0EJDVTqEaiuOyJ5xZpIsm9NgFOLTcKRRPQH8Meta } from "/builds/triyaru/desktop-frontend-2/pages/personal/cart/[id]/index.vue?macro=true";
import { default as _91_91path_93_93bu_BqtGrbdr0ntcY1dJkfQIEduF0bfvUNsNahKvEszoMeta } from "/builds/triyaru/desktop-frontend-2/pages/catalog/discont/[[path]].vue?macro=true";
import { default as onlineqldT8xuw_Ib4Hj6zss2F8FJ_UxdyKPPMgi8DhzGumYEMeta } from "/builds/triyaru/desktop-frontend-2/pages/3d/online.vue?macro=true";
import { default as indexD5y4nq0lz9YrmfLfEVEaIttMuxrNlYYZ2RBJg2kb8hsMeta } from "/builds/triyaru/desktop-frontend-2/pages/about/company/index.vue?macro=true";
import { default as indexoUcfcpYT4zNSfJCs4ENNsDJ_GCZUdkl6fjPkZEO2dggMeta } from "/builds/triyaru/desktop-frontend-2/pages/about/legal/index.vue?macro=true";
import { default as tenderYyBl33cWv98N5c8CLpDuXKUyXK2d_An6F8aQam7iLroMeta } from "/builds/triyaru/desktop-frontend-2/pages/about/tender.vue?macro=true";
import { default as indexYG9pVKaSiw4hPHwhDeXiRyKSo1rKRIN6hO2kyK_ALfgMeta } from "/builds/triyaru/desktop-frontend-2/pages/oauth/yandex/index.vue?macro=true";
import { default as indexsKS74L7CYp0DOF0FCjNpkYBpcSK1FYZgfBb5qn7hQvgMeta } from "/builds/triyaru/desktop-frontend-2/pages/personal/cart/index.vue?macro=true";
import { default as index4AwuWP5AHLFuYlh_u1TpQ3Ue2nNiE6MC7_MH_n0YdVgMeta } from "/builds/triyaru/desktop-frontend-2/pages/personal/favorites/index.vue?macro=true";
import { default as indexzefgL5EEXK3bOMOYZtucTmb76rrXeHdjZ8G49LeOra4Meta } from "/builds/triyaru/desktop-frontend-2/pages/personal/recent-view/index.vue?macro=true";
import { default as indexKOt5Zf3mTFoQMpXcfEVbs5kdqk4eSHxCLWmSPBJUO1YMeta } from "/builds/triyaru/desktop-frontend-2/pages/promo/credit/index.vue?macro=true";
import { default as index8CXvjAvvlnTfGu1uTsXXWGPPTPg0CAgXhfuP7rgmKpEMeta } from "/builds/triyaru/desktop-frontend-2/pages/catalog/[path]/[code]/index.vue?macro=true";
import { default as indexdaHx7VtptLkUh_vDH3c6KkmOnhgRvc0W_QSIn_J823kMeta } from "/builds/triyaru/desktop-frontend-2/pages/catalog/[path]/index.vue?macro=true";
import { default as _91code_935oIgPf58t_xUt0XxOLe_3clj9S_PDq29YsNs7wpv6pMMeta } from "/builds/triyaru/desktop-frontend-2/pages/news/[code].vue?macro=true";
import { default as indexOxDUiqDWQxL9JuFAGpP__0QoehIEq1pB8h1uRbSQ4ekMeta } from "/builds/triyaru/desktop-frontend-2/pages/promo/[path]/index.vue?macro=true";
import { default as index7TYO1KNQ74ifPEaRVfV1lJSv281dNWWWdiXl838kcicMeta } from "/builds/triyaru/desktop-frontend-2/pages/3d/index.vue?macro=true";
import { default as contactsTHpMpgu1Py_L_w7Y6keKVIt9iKtt_MMTBbJZe94vcz8Meta } from "/builds/triyaru/desktop-frontend-2/pages/about/index/contacts.vue?macro=true";
import { default as deffered_45paymentorj9T_fV88Qu6TFNsFZjxqD8yfatE3k9iRU4uMQ_L9UMeta } from "/builds/triyaru/desktop-frontend-2/pages/about/index/deffered-payment.vue?macro=true";
import { default as deliveryxvq9v3JMEkvIe9heNRhQYqisMYa5CkOYqqlbJrMhgNQMeta } from "/builds/triyaru/desktop-frontend-2/pages/about/index/delivery.vue?macro=true";
import { default as ecology4L22gjefbYVtrLrbAeOcp2cEP0peNjBN2Vk_u0FfX_gMeta } from "/builds/triyaru/desktop-frontend-2/pages/about/index/ecology.vue?macro=true";
import { default as productionFsp5cm_BRNWTRzY_zVgz5M6TRlhUEdUtGEp7DusmUJcMeta } from "/builds/triyaru/desktop-frontend-2/pages/about/index/production.vue?macro=true";
import { default as index__kINM1JXlRGnyhRvZulkA9LZf6_WqSsjgrE7dWziqQMeta } from "/builds/triyaru/desktop-frontend-2/pages/about/index/stores/index.vue?macro=true";
import { default as vacancykxlZHl9TqvM0Bx327_KVV7OJhzvapty7tP2dBrL7fVUMeta } from "/builds/triyaru/desktop-frontend-2/pages/about/index/vacancy.vue?macro=true";
import { default as warrantyf0vGZUdz8sTd68dYPrg3_pT3nmFkdj5hQJDRMQtjyI8Meta } from "/builds/triyaru/desktop-frontend-2/pages/about/index/warranty.vue?macro=true";
import { default as indexvzWROCKYxeuBKhtaADhcGYTZu0221MwM7pLAI32AUVUMeta } from "/builds/triyaru/desktop-frontend-2/pages/about/index.vue?macro=true";
import { default as indexcw9npOrEI_U7Pn7PYlI3B_RvvgxuQv_NGDmDGBDcnnsMeta } from "/builds/triyaru/desktop-frontend-2/pages/catalog/index.vue?macro=true";
import { default as indexa0u8Ury_ZXGlcyDvR56suRdEnOBtDbKKfFVX2hO29NkMeta } from "/builds/triyaru/desktop-frontend-2/pages/login/index.vue?macro=true";
import { default as indexwAavllOug_pYJnZ0xfYHruAcEzz0HeqNfpHros99NfkMeta } from "/builds/triyaru/desktop-frontend-2/pages/news/index.vue?macro=true";
import { default as ordersl5XN8NKBpujzseeGztFYwviwwf4j2y3eaqFs6GGFsEoMeta } from "/builds/triyaru/desktop-frontend-2/pages/personal/index/orders.vue?macro=true";
import { default as indexertKzWH4vxvQ3kt32846KB7FFsFzotnXbCiy9hJZGxYMeta } from "/builds/triyaru/desktop-frontend-2/pages/personal/index/index.vue?macro=true";
import { default as indexT2GQuSqsV5VhKA_SwQFg5QDiY5nkdelZTqnL_PvpPEIMeta } from "/builds/triyaru/desktop-frontend-2/pages/personal/index.vue?macro=true";
import { default as indexuqbMufxZumI84T20KK5STM9m4lXc951ctKsXQsKBp3UMeta } from "/builds/triyaru/desktop-frontend-2/pages/sales/index.vue?macro=true";
import { default as indexuwpMzGxa8NXCFP_wokerv8Was05UFalBnIK4QWisOPYMeta } from "/builds/triyaru/desktop-frontend-2/pages/search/index.vue?macro=true";
import { default as indextk8ykYwYRQu9qPfC_UoABmtnOJl6_B3YCTGahwrTp1AMeta } from "/builds/triyaru/desktop-frontend-2/pages/index.vue?macro=true";
export default [
  {
    name: "about-company-detail",
    path: "/about/company/detail",
    component: () => import("/builds/triyaru/desktop-frontend-2/pages/about/company/detail.vue")
  },
  {
    name: "about-legal-document-content",
    path: "/about/legal/document-content",
    component: () => import("/builds/triyaru/desktop-frontend-2/pages/about/legal/document-content.ts")
  },
  {
    name: "about-legal-nda",
    path: "/about/legal/nda",
    component: () => import("/builds/triyaru/desktop-frontend-2/pages/about/legal/nda.vue")
  },
  {
    name: "about-legal-offer",
    path: "/about/legal/offer",
    component: () => import("/builds/triyaru/desktop-frontend-2/pages/about/legal/offer.vue")
  },
  {
    name: "personal-cart-id",
    path: "/personal/cart/:id()",
    component: () => import("/builds/triyaru/desktop-frontend-2/pages/personal/cart/[id]/index.vue")
  },
  {
    name: "catalog-discont-path",
    path: "/catalog/discont/:path?",
    meta: _91_91path_93_93bu_BqtGrbdr0ntcY1dJkfQIEduF0bfvUNsNahKvEszoMeta || {},
    component: () => import("/builds/triyaru/desktop-frontend-2/pages/catalog/discont/[[path]].vue")
  },
  {
    name: "3d-online",
    path: "/3d/online",
    component: () => import("/builds/triyaru/desktop-frontend-2/pages/3d/online.vue")
  },
  {
    name: "about-company",
    path: "/about/company",
    component: () => import("/builds/triyaru/desktop-frontend-2/pages/about/company/index.vue")
  },
  {
    name: "about-legal",
    path: "/about/legal",
    component: () => import("/builds/triyaru/desktop-frontend-2/pages/about/legal/index.vue")
  },
  {
    name: "about-tender",
    path: "/about/tender",
    component: () => import("/builds/triyaru/desktop-frontend-2/pages/about/tender.vue")
  },
  {
    name: "oauth-yandex",
    path: "/oauth/yandex",
    component: () => import("/builds/triyaru/desktop-frontend-2/pages/oauth/yandex/index.vue")
  },
  {
    name: "personal-cart",
    path: "/personal/cart",
    component: () => import("/builds/triyaru/desktop-frontend-2/pages/personal/cart/index.vue")
  },
  {
    name: "personal-favorites",
    path: "/personal/favorites",
    component: () => import("/builds/triyaru/desktop-frontend-2/pages/personal/favorites/index.vue")
  },
  {
    name: "personal-recent-view",
    path: "/personal/recent-view",
    component: () => import("/builds/triyaru/desktop-frontend-2/pages/personal/recent-view/index.vue")
  },
  {
    name: "promo-credit",
    path: "/promo/credit",
    component: () => import("/builds/triyaru/desktop-frontend-2/pages/promo/credit/index.vue")
  },
  {
    name: "catalog-path-code",
    path: "/catalog/:path()/:code()",
    component: () => import("/builds/triyaru/desktop-frontend-2/pages/catalog/[path]/[code]/index.vue")
  },
  {
    name: "catalog-path",
    path: "/catalog/:path()",
    component: () => import("/builds/triyaru/desktop-frontend-2/pages/catalog/[path]/index.vue")
  },
  {
    name: "news-code",
    path: "/news/:code()",
    component: () => import("/builds/triyaru/desktop-frontend-2/pages/news/[code].vue")
  },
  {
    name: "promo-path",
    path: "/promo/:path()",
    component: () => import("/builds/triyaru/desktop-frontend-2/pages/promo/[path]/index.vue")
  },
  {
    name: "3d",
    path: "/3d",
    component: () => import("/builds/triyaru/desktop-frontend-2/pages/3d/index.vue")
  },
  {
    name: "about",
    path: "/about",
    component: () => import("/builds/triyaru/desktop-frontend-2/pages/about/index.vue"),
    children: [
  {
    name: "about-index-contacts",
    path: "contacts",
    component: () => import("/builds/triyaru/desktop-frontend-2/pages/about/index/contacts.vue")
  },
  {
    name: "about-index-deffered-payment",
    path: "deffered-payment",
    component: () => import("/builds/triyaru/desktop-frontend-2/pages/about/index/deffered-payment.vue")
  },
  {
    name: "about-index-delivery",
    path: "delivery",
    component: () => import("/builds/triyaru/desktop-frontend-2/pages/about/index/delivery.vue")
  },
  {
    name: "about-index-ecology",
    path: "ecology",
    component: () => import("/builds/triyaru/desktop-frontend-2/pages/about/index/ecology.vue")
  },
  {
    name: "about-index-production",
    path: "production",
    component: () => import("/builds/triyaru/desktop-frontend-2/pages/about/index/production.vue")
  },
  {
    name: "about-index-stores",
    path: "stores",
    component: () => import("/builds/triyaru/desktop-frontend-2/pages/about/index/stores/index.vue")
  },
  {
    name: "about-index-vacancy",
    path: "vacancy",
    component: () => import("/builds/triyaru/desktop-frontend-2/pages/about/index/vacancy.vue")
  },
  {
    name: "about-index-warranty",
    path: "warranty",
    component: () => import("/builds/triyaru/desktop-frontend-2/pages/about/index/warranty.vue")
  }
]
  },
  {
    name: "catalog",
    path: "/catalog",
    component: () => import("/builds/triyaru/desktop-frontend-2/pages/catalog/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: {"middleware":"not-auth"},
    component: () => import("/builds/triyaru/desktop-frontend-2/pages/login/index.vue")
  },
  {
    name: "news",
    path: "/news",
    component: () => import("/builds/triyaru/desktop-frontend-2/pages/news/index.vue")
  },
  {
    name: indexT2GQuSqsV5VhKA_SwQFg5QDiY5nkdelZTqnL_PvpPEIMeta?.name,
    path: "/personal",
    meta: {"middleware":"auth"},
    component: () => import("/builds/triyaru/desktop-frontend-2/pages/personal/index.vue"),
    children: [
  {
    name: "personal-index-orders",
    path: "orders",
    component: () => import("/builds/triyaru/desktop-frontend-2/pages/personal/index/orders.vue")
  },
  {
    name: "personal-index",
    path: "",
    component: () => import("/builds/triyaru/desktop-frontend-2/pages/personal/index/index.vue")
  }
]
  },
  {
    name: "sales",
    path: "/sales",
    component: () => import("/builds/triyaru/desktop-frontend-2/pages/sales/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/builds/triyaru/desktop-frontend-2/pages/search/index.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/builds/triyaru/desktop-frontend-2/pages/index.vue")
  }
]